import React from "react";
import styles from "./ProductSpecifications.module.css";
import { Specification } from "../Types/product.types";

interface ProductSpecificationsProps {
  aspect_ratio: {
    name: string;
  };
  tyer_type: {
    name: string;
  };
  tyer_ps: {
    name: string;
  };
  width: {
    name: string;
  };
  rim: {
    name: string;
  };
}

const ProductSpecifications: React.FC<ProductSpecificationsProps> = ({
  aspect_ratio,
  tyer_type,
  tyer_ps,
  width,
  rim,
}) => {
  // if (!specifications?.length) return null;

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.heading}>Detailed Specifications</h2>

      <div className={styles.table}>
        <div className={styles.row}>
          <span className={styles.label}>Width</span>
          <span className={styles.value}>{width?.name || "-"}</span>
        </div>

        <div className={styles.row}>
          <span className={styles.label}>Aspect Ratio</span>
          <span className={styles.value}>{aspect_ratio?.name || "-"}</span>
        </div>

        <div className={styles.row}>
          <span className={styles.label}>Rim Size</span>
          <span className={styles.value}>{rim?.name || "-"}</span>
        </div>

        <div className={styles.row}>
          <span className={styles.label}>Tyre Type</span>
          <span className={styles.value}>{tyer_type?.name || "-"}</span>
        </div>

        <div className={styles.row}>
          <span className={styles.label}>Vehicle Type</span>
          <span className={styles.value}>{tyer_ps?.name || "-"}</span>
        </div>
      </div>
    </div>
  );
};

export default ProductSpecifications;
